import { v4 } from 'uuid';

import { RecordData } from '../../helpers-classes';

import { AccessoriesItemData } from './data/accessory-assets.class';
import { AccessoryDataIn } from './types';

export const accessoryData = (dataIn: AccessoryDataIn = null): AccessoryDataIn => {
	const rd = new RecordData<AccessoryDataIn>(dataIn);
	const assetData = dataIn?.sku ? AccessoriesItemData.findBySku(dataIn.sku) : null

	const record: AccessoryDataIn = {
		id: rd.useNewOrPartial<string>('id', v4()),
		sku: dataIn?.sku ?? null,
		description: rd.useNewOrDefault<string | null>('description', assetData?.description ?? null),
		msrp: rd.useNewOrDefault<number>('msrp', assetData?.msrp ?? 0),
		pairedComponentSku: rd.useNewOrDefault('pairedAppliance', assetData?.pairedComponentSku ?? null),
		hsProductId: rd.useNewOrDefault<string | null>('hsProductId', assetData?.hsProductId ?? null)
	};

	return record;
};
